export default {
  offer: {
    en: 'Get a free {name} with purchases over {price}',
  },
}
